import React, { useState /*, useContext*/ } from "react";
import styled from "styled-components";
import Button from "./Button";
import Notification from "./Notification";
import Input from "./Input";
import { Link } from "react-router-dom";
import UserAPI from "../apis/UserAPI";
import { useHistory } from "react-router-dom";
import Modal from "./Modal";
import StampMessage from "./StampMessage";
// import { UserContext } from '../contexts/UserContext';

const Activation = () => {
  // const userContext = useContext(UserContext);

  let history = useHistory();

  const [code, setCode] = useState("");
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showState, setShowState] = useState(undefined);

  const activate = () => {
    if (loading) return;

    setLoading(true);

    const sanitized = {
      code: code.toUpperCase().trim().replace(/\s/g, ""),
    };

    let notification = null;
    if (sanitized.code.length !== 6) notification = "El código es inválido.";

    if (notification) {
      setNotification(notification);
      setLoading(false);
    } else {
      setNotification(null);
      UserAPI.activate(sanitized.code)
        .then(() => {
          setShowState("SUCCESS");
        })
        .catch((error) => {
          setShowState("FAILURE");
          setNotification(error);
        })
        .finally(() => setLoading(false));
    }
  };

  const ModalState = (
    <ModalStyled>
      <ContainerState>
        {showState === "SUCCESS" && (
          <StampMessage success text="Código activado!" />
        )}
        {showState === "FAILURE" && (
          <StampMessage wrong text="Ocurrió un error" />
        )}
        <ButtonState
          text="OK"
          tertiary
          onClick={() => {
            if (showState === "SUCCESS") history.push("/home");
            else if (showState === "FAILURE") setShowState(false);
          }}
        />
      </ContainerState>
    </ModalStyled>
  );

  return (
    <Container>
      {showState && ModalState}
      <Wrapper>
        <Title>Activación</Title>
        <Description>
          La activación debe hacerse en un dispositivo de uso personal.
        </Description>
        {notification && <NotificationStyled message={notification} />}
        <InputStyled
          placeholder="Código"
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
        <Buttons>
          <ButtonStyled
            as={ButtonLink}
            to="/login"
            text="Cancelar"
            onClick={() => history.goBack()}
            secondary
          />
          <ButtonStyled
            text="Aceptar"
            loading={loading}
            onClick={activate}
            primary
          />
        </Buttons>
      </Wrapper>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const Title = styled.div`
  align-self: flex-start;
  font-size: 1.5em;
  font-weight: 600;

  margin-bottom: 15px;
`;

const Description = styled.div`
  align-self: flex-start;
  font-size: 0.9em;

  margin-bottom: 25px;
`;

const NotificationStyled = styled(Notification)`
  margin: 0px 0px 20px 0px;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const ButtonLink = (props) => <Button as={Link} {...props} />;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
`;

const Buttons = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 240px) {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

const ModalStyled = styled(Modal)`
  max-width: 220px;
  width: 100%;
`;

const ContainerState = styled.div`
  padding: 20px;
  & > * {
    margin: 5px;
  }
`;

const ButtonState = styled(Button)`
  margin-top: 30px;
`;

export default Activation;
